import {MuiPickersOverrides} from '@material-ui/pickers/typings/overrides';
import {Theme} from '@material-ui/core/styles/createMuiTheme';

export const createMuiPickersYearOverrides = ({
    palette,
    spacing,
    typography
}: Theme): MuiPickersOverrides['MuiPickersYear'] => ({
    root: {
        justifyContent: 'flex-start',
        color: palette.text.secondary,
        minHeight: spacing(8),
        maxHeight: spacing(8),
        padding: spacing(0, 4),
        fontSize: '14px'
    },
    yearSelected: {
        margin: spacing(0, 0),
        color: palette.text.primary,
        backgroundColor: palette.action.selected,
        '&:focus': {
            color: palette.text.primary
        }
    }
});
